module.exports = __webpack_public_path__ + "img/news1-4.b91070d8.jpeg";